export default __webpack_public_path__ + "static/lilnadas-cards-story-2-9ab82775e24cf2b19edb64aae5e4d824.png";